import axios from 'axios';
import { API_URL } from '../../utils/constants';

class PurchaseOrderService {
    async getCompanyDetailsAndProducts(data) {
        const url = `${API_URL}get-company-details-and-products/`;
        const headers = {
            'Content-Type': 'application/json'
        };
        let formData = data;
        return axios({
            url: url,
            method: 'POST',
            data: formData,
            headers: headers
        }).then(function (response) {
            return response;
        }).catch(function (error) {
            return error.response;
        });
    }

    async getAddress(data) {
        const url = `${API_URL}get-address/`;
        const headers = {
            'Content-Type': 'application/json'
        };
        let formData = data;
        return axios({
            url: url,
            method: 'POST',
            data: formData,
            headers: headers
        }).then(function (response) {
            return response;
        }).catch(function (error) {
            return error.response;
        });
    }

    async saveAddress(data) {
        const url = `${API_URL}save-address/`;
        const headers = {
            'Content-Type': 'application/json'
        };
        let formData = data;
        return axios({
            url: url,
            method: 'POST',
            data: formData,
            headers: headers
        }).then(function (response) {
            return response;
        }).catch(function (error) {
            return error.response;
        });
    }

    async deleteAddress(data) {
        const url = `${API_URL}delete-address/`;
        const headers = {
            'Content-Type': 'application/json'
        };
        let formData = data;
        return axios({
            url: url,
            method: 'POST',
            data: formData,
            headers: headers
        }).then(function (response) {
            return response;
        }).catch(function (error) {
            return error.response;
        });
    }

    async savePurchaseOrderData(data) {
        const url = `${API_URL}save-purchase-order-data/`;
        const headers = {
            'Content-Type': 'application/json'
        };
        let formData = data;
        return axios({
            url: url,
            method: 'POST',
            data: formData,
            headers: headers
        }).then(function (response) {
            return response;
        }).catch(function (error) {
            return error.response;
        });
    }

    async updatePurchaseOrderData(data) {
        const url = `${API_URL}update-purchase-order-data/`;
        const headers = {
            'Content-Type': 'application/json'
        };
        let formData = data;
        return axios({
            url: url,
            method: 'POST',
            data: formData,
            headers: headers
        }).then(function (response) {
            return response;
        }).catch(function (error) {
            return error.response;
        });
    }

    async exportPurchaseOrderPDF(data) {
        const url = `${API_URL}export-purchase-order-pdf`;

        return axios({
            url: url,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            data: data,
            responseType: 'blob'
        });
    }

    async exportPurchaseOrderExcel(data) {
        const url = `${API_URL}export-purchase-order-excel`;

        return axios({
            url: url,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            data: data,
            responseType: 'blob'
        });
    }

    async sharePurchaseOrder(payload) {
        const url = `${API_URL}share-purchase-order/`;
        const headers = {
            'Content-Type': 'application/json',
        };

        return axios({
            url: url,
            method: 'POST',
            headers: headers,
            data: payload
        })
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response ? error.response.data : { error: 'Unknown error' };
            });
    }

    async checkPoNumberExists(data) {
        const url = `${API_URL}check-po-number-exists/`;
        const headers = {
            'Content-Type': 'application/json'
        };
        return axios({
            url: url,
            method: 'POST',
            data: data,
            headers: headers
        }).then(function (response) {
            return response;
        }).catch(function (error) {
            return error.response;
        });
    }

    async getPurchaseOrdersHistory(data) {
        const url = `${API_URL}get-purchase-orders-history/`;
        const headers = {
            'Content-Type': 'application/json'
        };
        return axios({
            url: url,
            method: 'POST',
            data: data,
            headers: headers
        }).then(function (response) {
            return response;
        }).catch(function (error) {
            return error.response;
        });
    }

    async getPurchaseOrderDetails(data) {
        const url = `${API_URL}get-purchase-order-details/`;
        const headers = {
            'Content-Type': 'application/json'
        };
        return axios({
            url: url,
            method: 'POST',
            data: data,
            headers: headers
        }).then(function (response) {
            return response;
        }).catch(function (error) {
            return error.response;
        });
    }
    async getProductInventory(productNum) {
        const url = `${API_URL}get-product-inventory?product_num=${encodeURIComponent(productNum)}`;
        const headers = {
            'Content-Type': 'application/json'
        };
        return axios({
            url: url,
            method: 'GET',
            headers: headers
        }).then(function (response) {
            return response;
        }).catch(function (error) {
            return error.response;
        });
    }

}

export default PurchaseOrderService;
